<template>
  <!-- 创建积分优惠券 -->
  <div class="createPlayStep new-input-box">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-button
        type="blue"
        :styleTextObj="{ width: 'auto', height: '24px' }"
        @click="retrunMethod()"
        >返回</jd-button
      >
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <!-- :class="{ formBox: localStep != 0 }" -->
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStep">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <div class="firststep" v-if="localStep == 0">
        <div class="activeEdit_bottom">
          <div class="template">
            <div style="width: 82px; padding-top: 5px">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in tempSwitchList"
                :key="item.id"
                :class="{ activeTem: index == 0 }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div
                class="temImg_content"
                @click="handleOpen()"
                style="border: 1px solid #d4e2ff"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg"
                      alt=""
                    />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: #eaf1ff"
                ></div>
              </div>
              <!-- hover -->
              <div
                class="temImg_content_bgshadow"
                style="height: 432px; border-radius: 8px"
                @click="handleOpen()"
              >
                <div class="temImg_content_bgshadow_codeDZ">
                  <img
                    style="width: 100%"
                    src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div class="temImg" v-for="item in giftList" :key="item.id">
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img
                    style="width: 100%; max-height: 380px"
                    :src="item.templateUrl"
                    alt=""
                  />
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.imageName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="qrCodeIMG1"
                  ref="qrCodeIMG1"
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_btn pointer"
                  @click="nextStepKai(item)"
                >
                  使用此模板
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="localStep == 1">
        <!-- 兑换表单 -->
        <main class="main">
          <el-form :model="form" :rules="rules" ref="form" label-width="160px">
            <el-form-item label="礼品名称:" required>
              <el-input
                v-model="form.activityName"
                maxlength="15"
                show-word-limit
                placeholder="请填入活动名称"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <!-- 活动对象 -->
            <informationForm
              @selectPeopleSure="selectPeopleSure"
              @getMemberFn="resetMemberFn"
              :defaultActMember.sync="form.ruleDTO.activityTargetType"
              :plusObject.sync="form.ruleDTO.plusObject" 
              :isCheckOpenCardTime.sync="form.ruleDTO.isCheckOpenCardTime" 
              :openCardStartTime.sync="form.ruleDTO.openCardStartTime" 
              :openCardEndTime.sync="form.ruleDTO.openCardEndTime" 
              :peopleSelected.sync="peopleSelected"
              v-model="form.ruleDTO"
              :activityId="9"
              :localStepNum="16"
              :isEdit="false"
              :disabled="false"
              :needNonMember="true"
              :showOpenCardTip="true"
              :basicInformation="false"
              :customerPaperwork="customerPaperwork"
              @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
            >
            </informationForm>
            <!-- <el-form-item label="礼品图片:" required>
              <el-upload
                ref="upload"
                action="#"
                list-type="picture-card"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :http-request="httpRequest"
              >
                <img
                  v-if="form.logo"
                  :src="form.logo"
                  style="width: 146px; height: 146px"
                />
                <i class="el-icon-plus" v-else></i>
              </el-upload>
              <span style="color: red; font-size: 14px"
                >建议尺寸：750*420像素，图片大小不能超过1.5MB，类型：JPG、PNG</span
              >
            </el-form-item> -->

            <el-form-item label="上下架时间:" required>
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="form.startTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 135px; font-size: 12px"
                  class="time1"
                  @change="activityTimeChange"
                  :picker-options="pickerOptionsValueStart"
                  :clearable="false"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="form.endTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 150px; font-size: 12px"
                  class="time2"
                  @change="activityTimeChange"
                  :picker-options="pickerOptionsValueEnd"
                  :clearable="false"
                >
                </el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="clearTime()"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
              <span class="lastTime">
                活动持续
                <span style="color: #2768ff">{{ timeDay }}</span> 天
                <span style="color: #2768ff">{{ timeOut }}</span> 小时
                <el-tooltip
                  class="item"
                  effect="light"
                  content="活动有效期不可超过订购有效期"
                  placement="bottom"
                >
                  <el-button type="text" style="width: 35px">
                    <i class="el-icon-question" style="color: #ccc"></i>
                  </el-button>
                </el-tooltip>
              </span>
            </el-form-item>

            <el-form-item label="店铺类型:" required>
              <el-radio-group
                v-model="form.venderType"
                @change="changeShopType"
                disabled
              >
                <el-radio :label="1">自营店铺</el-radio>
                <el-radio :label="0">POP店铺</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- venderType  自营，false非自营 -->
            <el-form-item label="选择令牌:" required v-if="venderType">
              <jd-button type="blue" @click="selectToken">选择令牌</jd-button>
              <div v-if="tokenDetail.tokenId">
                <div class="tokenDetial-item">
                  <span>令牌名称：</span>
                  <div class="flex-1">
                    {{ tokenDetail.name || "" }}
                  </div>
                </div>
                <div class="tokenDetial-item">
                  <span>令牌ID：</span>
                  <div class="flex-1">
                    {{ tokenDetail.tokenId || "" }}
                  </div>
                </div>
                <div class="tokenDetial-item">
                  <span>秘钥：</span>
                  <div class="flex-1">
                    {{ tokenDetail.secretKey || "" }}
                  </div>
                </div>
                <div class="tokenDetial-item">
                  <span>令牌有效时间：</span>
                  <div class="flex-1">
                    {{ tokenDetail.startTime + "-" + tokenDetail.endTime }}
                  </div>
                </div>
                <div class="tip-color">注意：促销有效时间等于令牌有效时间</div>
              </div>
            </el-form-item>

            <!-- 自营店铺显示选择商品 -->
            <el-form-item
              label="选择商品:"
              required
              v-if="!venderType || form.tokenId"
            >
              <jd-button type="blue" @click="dialogForm">选择商品</jd-button>
            </el-form-item>

            <!-- 促销价格设置 -->
            <!-- <el-form-item
              label="促销价格:"
              v-if="!venderType || form.tokenId"
            >
              <el-select
                style="width: 100px"
                v-model="form.globalConfig.priceType"
                :disabled="activityData.isStart"
                @change="form.globalConfig.priceVal = ''"
              >
                <el-option label="折扣" :value="0"></el-option>
                <el-option label="减价" :value="1"></el-option>
              </el-select>
              <span style="margin: 0 8px">{{
                form.globalConfig.priceType == 0
                  ? "统一打"
                  : "统一减"
              }}</span>
              <el-input
                v-if="form.globalConfig.priceType == 0"
                style="width: 100px"
                v-model="form.globalConfig.priceVal"
                placeholder="请输入"
                @input="
                  form.globalConfig.priceVal = getNumberData(
                    2,
                    $event,
                    1,
                    0,
                    9.9
                  )
                "
                :disabled="activityData.isStart"
              ></el-input>
              <el-input
                v-else
                style="width: 100px"
                v-model="form.globalConfig.priceVal"
                placeholder="请输入"
                @input="
                  form.globalConfig.priceVal = getNumberData(
                    2,
                    $event,
                    1,
                    0
                  )
                "
                :disabled="activityData.isStart"
              ></el-input>
              <span style="margin: 0 8px">{{
                form.globalConfig.priceType == 0 ? "折" : "元"
              }}</span>
              <img v-if="!activityData.isStart" @click="
                  changeGoodsPrice(
                    form.globalConfig.priceVal,
                    form.globalConfig.priceType == 0 ? 1 : 2
                  )
                " src="https://cdn-image.yucrm.cn/6f6b66b21e0349d7ae916e9829097abb.png" class="confirm-icon ml12" alt="">
            </el-form-item>

            <el-form-item
              label="选择抹零:"
              v-if="!venderType || form.tokenId"
            >
              <el-select
                style="width: 150px"
                v-model="form.globalConfig.roundMode"
                :disabled="activityData.isStart"
              >
                <el-option label="不抹零" :value="0"></el-option>
                <el-option label="取整" :value="1"></el-option>
                <el-option label="抹去分" :value="2"></el-option>
              </el-select>
              <img v-if="!activityData.isStart"  @click="changeGoodsPrice(1, 4)" src="https://cdn-image.yucrm.cn/6f6b66b21e0349d7ae916e9829097abb.png" class="confirm-icon ml20" alt="">
            </el-form-item>

            <el-form-item
              label="统一奖品数量:"
              v-if="!venderType || form.tokenId"
            >
              <span>统一</span>
              <el-input
                style="width: 100px; margin: 0 8px"
                v-model="form.globalConfig.remanentAmount"
                placeholder="请输入"
                @input="
                  form.globalConfig.remanentAmount =
                    getNumberData(2, $event, 0, 1)
                "
                :disabled="activityData.isStart"
              ></el-input>
              件
              <img v-if="!activityData.isStart"  @click=" changeGoodsPrice(form.globalConfig.remanentAmount,3)" src="https://cdn-image.yucrm.cn/6f6b66b21e0349d7ae916e9829097abb.png" class="confirm-icon ml20" alt=""></img>
            </el-form-item> -->

            <el-form-item
              label="设置商品:"
              required
              v-if="!venderType || form.tokenId"
            >
              <!-- 表格 -->
              <div>
                <jd-table :tableData="form.goodsList" style="width: 1100px">
                  <el-table-column label="商品信息" prop="skuName">
                    <template slot-scope="scope">
                      <div>商品信息: {{ scope.row.skuName }}</div>
                      <div>skuId: {{ scope.row.skuId }}</div>
                    </template>
                  </el-table-column>

                  <el-table-column label="京东价" prop="jdPrice">
                  </el-table-column>
                  <el-table-column label="折扣" v-if="!venderType">
                    <template slot-scope="scope">
                      <el-input
                        style="width: 80px"
                        v-model.number="scope.row.discount"
                        placeholder="请输入"
                        @input="
                          (scope.row.discount = getNumberData(
                            2,
                            $event,
                            1,
                            1,
                            10
                          )),
                            getDiscountAmount(scope.row)
                        "
                        :disabled="activityData.isStart"
                      ></el-input>
                      折
                    </template>
                  </el-table-column>
                  <el-table-column label="减价" v-if="!venderType">
                    <template slot-scope="scope">
                      <el-input
                        style="width: 80px"
                        v-model.number="scope.row.discountAmount"
                        placeholder="请输入"
                        @input="
                          (scope.row.discountAmount = getNumberData(
                            1,
                            $event,
                            1,
                            0,
                            scope.row.jdPrice
                          )),
                            getDiscount(scope.row)
                        "
                        :disabled="activityData.isStart"
                      ></el-input>
                      元
                      <div class="red-border" v-if="scope.row.discountValueValid">
                        输入范围0.01~{{ scope.row.jdPrice }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="促销价"
                    prop="payPrice"
                    v-if="!venderType"
                  >
                  </el-table-column>
                  <el-table-column
                    label="奖品图片"
                    width="200"
                  >
                    <template slot-scope="scope">
                      <img
                        v-if="scope.row.logo"
                        :src="scope.row.logo"
                        style="width: 56px; height: 56px"
                      />
                    </template>
                  </el-table-column>
                </jd-table>
              </div>
            </el-form-item>

            <!-- 商品限购 -->
            <el-form-item
              label="商品限购:"
              v-if="!venderType || form.tokenId"
            >
              <span style="margin-right: 15px;">每笔订单中每个商品最少购买</span>
              <el-input
                style="width: 60px"
                v-model.number="form.minItemNum"
                placeholder="请输入"
                :disabled="activityData.isStart"
              ></el-input>
              <span style="margin: 0 15px;">件，最多购买</span>
              <el-input
                style="width: 60px"
                v-model.number="form.maxItemNum"
                placeholder="请输入"
                :disabled="activityData.isStart"
              ></el-input>
              <span>件，才能展示并享受专享价</span>
            </el-form-item>

            <el-form-item v-if="!venderType || form.tokenId">
              <div style="color: #999; font-size: 12px;">
                注：①按SKU限购，每单每个SKU不超过限购件数，才能享受促销价；不填则为不限购；②默认每个账号限购1次
              </div>
            </el-form-item>

            <!-- 划线价 -->
            <el-form-item label="划线价:" required>
              <el-input
                v-model="form.linePrice"
                style="width: 136px"
                disabled
              ></el-input>
              元
            </el-form-item>

            <!-- 兑换消耗 -->
            <el-form-item label="兑换消耗:" required>
              <el-input
                v-model="points"
                @input="points = getNumberData(1, $event, 0, 1)"
                style="width: 136px; margin-right: 5px"
              ></el-input
              >积分 +
              <el-input
                v-model="form.payPrice"
                :disabled="!venderType"
                style="width: 136px; margin-left: 10px"
              ></el-input>
              元
            </el-form-item>

            <el-form-item >
              <div style="color: red;">
                 注：价格建议编辑显示优惠后的价格，如该商品使用令牌后用户达成令牌条件后的到手价格；
              </div>
            </el-form-item>

            <!-- 礼品兑换总量 -->
            <el-form-item label="礼品兑换总量:" required>
              <el-input
                v-model="form.quantityTotal"
                @input="form.quantityTotal = getNumberData(1, $event, 0, 1)"
                style="width: 136px"
              ></el-input>
              份
            </el-form-item>

            <!-- 每日最多可兑 -->
            <el-form-item label="每日最多可兑:" required>
              <el-radio-group v-model="form.exchangePerDayLimit">
                <el-radio :label="0">不限制</el-radio>
                <el-radio :label="1">限制</el-radio>
              </el-radio-group>
              <el-input
                v-model="form.exchangeNumPerDay"
                @input="form.exchangeNumPerDay = getNumberData(1, $event, 0, 0)"
                style="width: 136px; margin-left: 20px"
                :disabled="form.exchangePerDayLimit == 0"
              ></el-input>
              份
            </el-form-item>

            <!-- 会员兑换规则 -->
            <el-form-item label="会员兑换规则:" required>
              <el-radio-group v-model="form.exchangeMemberTimes">
                <el-radio :label="1">活动期间可兑换1次</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="兑换所需等级:" required>
              <div class="level-wrap">
                <el-checkbox-group v-model="memberLe" @change="checkListchange">
                  <el-checkbox :label="memberLe">全部</el-checkbox>
                </el-checkbox-group>
                <el-checkbox-group
                  v-model="level"
                  v-for="(item, index) in memberLevelList"
                  :key="index"
                  @change="checkTheChange"
                >
                  <el-checkbox
                    :label="item.value"
                    :disabled="memberLe == true"
                    v-if="item.label"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </el-form-item>

            <el-form-item label="规则说明:" required>
              <div
                style="
                  width: 720px;
                  backroundcolor: rgba(250, 250, 250, 1);
                  padding-top: 8px;
                "
              >
                <el-input
                  type="textarea"
                  class="textarea"
                  style="width: 704px"
                  resize="none"
                  :rows="6"
                  v-model="form.ruleDescription"
                ></el-input>

                <div style="margin-top: 8px">
                  <jd-button type="blue" @click="generativerule"
                    >生成规则</jd-button
                  >
                  <div class="rule-tip">
                    <jd-tip color="gley">
                      提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                    </jd-tip>
                  </div>
                </div>
              </div>
            </el-form-item>
            <div class="pd20">
              <jd-title label="展示店铺"></jd-title>
            </div>
            <el-form-item label="小程序店铺信息：" label-width="150px">
                <el-radio-group v-model="customerPaperwork.shopNameType">
                    <el-radio :label="0">统一显示配置店铺</el-radio>
                    <el-radio :label="2">不显示店铺信息</el-radio>
                </el-radio-group>
            </el-form-item>
            <!-- 新增字段 -->
            <el-form-item label="是否重点活动:" required>
              <div class="flexc-cen-x mt10">
                <el-radio-group v-model="isKeyActivity" :disabled="isDisabledNew">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
                <el-tooltip class="item" effect="dark" placement="top">
                  <template slot="content">
                    <div>
                      大促、品牌高流量等活动建议选「是」，官方会有一定的技术保障资源倾斜
                    </div>
                  </template>
                  <i class="new-icon-box ml8"></i>
                </el-tooltip>
              </div>
            </el-form-item>
            <el-form-item label="活动投放位置:" required>
              <el-checkbox-group v-model="placementPosition" :disabled="isDisabledNew">
                <el-checkbox label="HOME">京东APP首场曝光位</el-checkbox>
                <el-checkbox label="CHANNEL">大促主会场资源</el-checkbox>
                <el-checkbox label="SEARCH_RECOMMEND">搜索与推荐链路</el-checkbox>
                <el-checkbox label="SHOP">店铺</el-checkbox>
                <el-checkbox label="OUTSIDE">域外曝光</el-checkbox>
                <el-checkbox label="OTHER">其他渠道</el-checkbox>
                <el-tooltip class="item" effect="dark" placement="top">
                  <template slot="content">
                    <div>上方选择为【是】时请选择活动投放位置便于官方监控流量</div>
                  </template>
                  <i class="new-icon-box ml8"></i>
                </el-tooltip>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </main>
      </div>
    </div>
    <div class="create_bottom" v-if="localStep != 0">
      <jd-button @click="retrunMethod()" style="margin-right: 8px"
        >返回上一页</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >存为草稿</jd-button
      >
      <jd-button type="blue" @click="setActivity" v-preventReClick>
        保存并完成设置
      </jd-button>
    </div>
    <!-- 选择商品弹窗 -->
    <el-dialog title="选择商品" :visible.sync="dialogFormVisible" width="820px">
      <jd-form
        style="margin-bottom: 16px"
        ref="goodsRef"
        :form-info="commodityList"
        @search="searchContent"
      >
      </jd-form>
      <jd-table
        :tableData="tableShopData"
        :loading="loading"
        :pageInfo="{
          pageNum: pageInfo.current,
          pageSize: pageInfo.size,
          total: totalList,
        }"
        @handlePage="handleChangePage"
      >
        <el-table-column width="100" label="商品图片">
          <template slot-scope="scope">
            <img
              :src="scope.row.logo"
              alt="商品图片"
              style="height: 60px; width: 60px; margin-top: 8px"
            />
          </template>
        </el-table-column>
        <el-table-column prop="skuName" label="商品名称" width="300">
          <template slot-scope="scope">
            <a :href="scope.row.itemUrl" target="_blank"
              >{{ scope.row.skuName }}<br />
              ¥{{ scope.row.jdPrice }}</a
            >
          </template>
        </el-table-column>
        <el-table-column prop="skuId" label="SKU ID" width="200">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="chooseShop(scope.row)"
              v-loading="sureLoading"
              style="width: 50px"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </jd-table>
    </el-dialog>
    <!-- 保存并完成设置弹框 -->
    <el-dialog
      title="重要提示"
      v-if="showSetDialog"
      :visible.sync="showSetDialog"
      width="800"
      @close="showSetDialog = false"
    >
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <jd-button @click="showSetDialog = false">取消</jd-button>
        <jd-button
          type="break"
          style="margin-left: 8px"
          @click="handleDialogCloseAnoth"
          >确定</jd-button
        >
      </div>
    </el-dialog>
    <!-- 选择令牌弹窗 -->
    <selectTokenDialog
      v-if="selectTokenDialog"
      v-model="selectTokenDialog"
      :tokenId="form.tokenId"
      @confirm="confirmToken"
      :isSetDisabled="true"
    ></selectTokenDialog>
  </div>
</template>

<script>
import informationForm from "@/views/interactiveMarketing/activity/components/informationForm.vue";
import inputForm from "@/components/inputForm";
import { querydetail } from "@/api/jhk/integralCenter/couponWriteController.js";
import QRCode from "qrcodejs2";
import {
  getTaobaoItemListSku,
  getSellercats,
} from "@/api/jhk/analysis/ware-controller.js";

import {
  uploadpic,
  addMoneyActivity,
  inquireActivity,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { allAccount } from "@/api/jhk/integralCenter/prizeCenter.js";
import selectTokenDialog from "@/views/interactiveMarketing/promo/components/selectTokenDialog.vue";
import { checkProduct } from "@/api/jhk/activity.js";
export default {
  props: {
    stepNum: {
      type: Number,
      default: 0,
    },
    tabActive: {
      type: Number,
      default: 29,
    },
    valueRow: null,
    activityData: {},
    isStart: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    inputForm,
    selectTokenDialog,
    informationForm,
  },
  computed: {
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.singleCopy;
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    isDisabledNew() {
      let flag = true;
      if(!this.valueRow||JSON.stringify(this.valueRow) == '{}') {
        flag = false
      }
      if(this.valueRow&&this.valueRow.status==5) {
        flag = false
      }
      if(this.activityData&&(this.activityData.isCopy||this.activityData.singleCopy)) {
        flag = false
      }
      if((this.activityData.id==8||this.activityData.id==19||this.activityData.id==50)&&this.activityData.status==5) {
        flag = false
      }
      return flag
    }
  },
  watch: {
    localStep(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
          this.allSearch();
        });
      }
    },
    venderType: {
      handler(newVal) {
        if (newVal) {
          this.form.venderType = 1;
        } else {
          this.form.venderType = 0;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      customerPaperwork: { shopNameType: 0 },
      sureLoading: false,
      isKeyActivity: 0,
      placementPosition: [],
      loading: false,
      tokenDetail: {},
      selectTokenDialog: false,
      showSetDialog: false,
      checked: false, //  是否明确活动规则 保存后弹窗内的勾选框
      giftList: [],
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: 1,
        },
      ],
      localStep: this.stepNum,
      pickerOptionsValueStart: {
        disabledDate: (time) => {
          // 禁用今天之前的日期和软件有效期之后的日期
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() > new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf()
          );
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            (this.form.startTime &&
              time.getTime() < new Date(this.form.startTime).valueOf()) ||
            (this.tokenDetail.endTime &&
              time.getTime() > new Date(this.tokenDetail.endTime).valueOf())
          );
        },
      },
      fileList: [],
      memberLevelPointsDTOList: [
        // {
        //   level:1,
        //   allow:true,
        //   point:10
        // }
      ],
      butActive: 1,
      commodityList: [
        {
          label: "商品类目：",
          placeholder: "请选择",
          prop: "categoryId",
          type: "cascadeSelect",
          value: "",
          options: [],
          multiple: true,
          showAllLevels: false,
          width: 240,
        },
        {
          label: "SKU ID：",
          prop: "skuId",
          placeholder: "请输入SKU ID",
          // isNumber: true,
          type: "Input",
          value: "",
          width: 240,
        },
        {
          label: "商品名称：",
          prop: "skuName",
          placeholder: "请输入商品名称",
          type: "Input",
          width: 240,
        },
        {
          label: "商品状态：",
          prop: "skuStatus",
          value: 1,
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "上架", value: 1 },
            { label: "下架", value: 2 },
          ],
          width: 240,
        },
      ],
      points: null, // 兑换消耗积分
      // 表单值
      form: {
        logo: "",
        activityName: "",
        ruleDescription: "",
        startTime: null,
        endTime: null,
        memberLevelPoints: "",
        // 新增字段
        linePrice: null, // 划线价
        payPrice: null, // 兑换消耗折扣价
        quantityTotal: null, // 礼品兑换总量
        exchangeNumPerDay: null, // 0:不限制, 1:限制 每日最多可兑
        exchangePerDayLimit: 0,
        exchangeMemberTimes: 1, // 会员兑换规则：1-活动期间可兑换1次
        venderType: 1,
        tokenId: "",
        // 全局商品配置（给前端计算使用）
        // globalConfig: {
        //   priceType: 0, // 促销价格：0折扣 1减价
        //   priceVal: null, // 促销价格对应值
        //   roundMode: 0, // 抹零：0不抹零 1取整 2抹去分
        //   remanentAmount: null, // 统一奖品数量
        // },
        minItemNum: null, // 商品最少购买件数
        maxItemNum: null, // 商品最多购买件数
        // 商品列表数据
        goodsList: [],
        ruleDTO: {
          activityTargetType: '1',
          partner: ["-1"],
          allowLevel: "-1",
          plusObject: 0,
          crowdIds: "",
          firstOpenCardTimeType: 0,
          openCardBeforeDay: "",
          orderCompleteLimitCount: "",
          orderCompleteMaxCount: "",
          orderCompleteLimitPayment: "",
          orderCompleteMaxPayment: "",
          lastOrderCompleteTimeType: 0,
          lastOrderCompleteStartDay: "",
          lastOrderCompleteEndDay: "",
          lastOrderCompleteStartTime: "",
          lastOrderCompleteEndTime: "",
          isCheckOpenCardTime: "",
          openCardStartTime: "",
          openCardEndTime: "",
        },
      },
      level: [],
      memberLevelList: [
        // { value: "全部", label: -1, point: "", levelName: "全部" },
        // { value: "非会员", label: 0, point: "", levelName: "非会员" },
        // { value: "一星会员", label: 1, point: "", levelName: "一星会员" },
        // { value: "二星会员", label: 2, point: "", levelName: "二星会员" },
        // { value: "三星会员", label: 3, point: "", levelName: "三星会员" },
        // { value: "四星会员", label: 4, point: "", levelName: "四星会员" },
        // { value: "五星会员", label: 5, point: "", levelName: "五星会员" },
      ],
      memberLevelListchange: [],
      // 表单校验
      rules: {
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
      },
      startTime: null,
      endTime: null,
      isLevelSet: false,
      islabled: false,
      dialogFormVisible: false,
      selectedStore: {}, // 选中的店铺信息
      // 添加优惠券显示隐藏状态控制
      addCouponIsShow: false,
      selfSupportAddCouponIsShow: false,

      //上传图片
      dialogImageUrl: "",
      dialogVisible: false,
      tableShopData: [],
      couponTxt: {},
      totalList: 0,
      currentPage: 1,
      couponId: 0,
      formShopList: {
        categoryId: "",
        skuId: "",
        skuStatus: 1,
        skuName: "",
      },
      pageInfo: { current: 1, size: 5 },
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      memberLe: true,
      spliceData: 0,
      quantityBalance: 0,
      useFullLevel: [],
      isCopy: false,
      isDraft: false,
      peopleSelected: [],
    };
  },
  mounted() {
    // 页面进入埋点
    this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
    this.getLevel();
    this.init();
    this.allSearch();
    if (!this.valueRow) {
      // 当前时间加10分钟
      let expireTime = new Date(this.$getDate(30)[0]); // 当前时间
      expireTime.setMinutes(expireTime.getMinutes() + 5); // 增加10分钟
      const year = expireTime.getFullYear();
      const month = String(expireTime.getMonth() + 1).padStart(2, '0');
      const day = String(expireTime.getDate()).padStart(2, '0');
      const hours = String(expireTime.getHours()).padStart(2, '0');
      const minutes = String(expireTime.getMinutes()).padStart(2, '0');
      const seconds = String(expireTime.getSeconds()).padStart(2, '0');
      this.form.startTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      // this.form.startTime = expireTime;//
      this.form.endTime = this.$getDate(30)[1];
      this.activityTimeChange();
    }
  },
  methods: {
    resetMemberFn(val) {
      this.peopleSelected = [];
      this.form.ruleDTO.partner = ["-1"];
      this.form.ruleDTO.firstOpenCardTimeType = 0;
      this.form.ruleDTO.openCardBeforeDay = "";
      this.form.ruleDTO.orderCompleteLimitCount = "";
      this.form.ruleDTO.orderCompleteMaxCount = "";
      this.form.ruleDTO.orderCompleteLimitPayment = "";
      this.form.ruleDTO.orderCompleteMaxPayment = "";
      this.form.ruleDTO.lastOrderCompleteTimeType = 0;
      this.form.ruleDTO.lastOrderCompleteStartDay = "";
      this.form.ruleDTO.lastOrderCompleteEndDay = "";
      this.form.ruleDTO.lastOrderCompleteStartTime = "";
      this.form.ruleDTO.lastOrderCompleteEndTime = "";
      this.form.ruleDTO.plusObject = 0;
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    getDiscountAmount(row) {
      if (row.discount) {
        row.payPrice = row.jdPrice * row.discount * 0.1;
        row.discountAmount = row.jdPrice - row.payPrice;
        this.form.payPrice = row.payPrice.toFixed(2);;
      } else {
        row.discountAmount = "";
        row.payPrice = row.jdPrice.toFixed(2);
        this.form.payPrice = row.jdPrice.toFixed(2);
      }
    },
    getDiscount(row) {
      if (
        row.jdPrice > 0 &&
        Number(row.discountAmount) >= 0 &&
        Number(row.discountAmount) <= row.jdPrice
      ) {
        const discountAmount = row.jdPrice - row.discountAmount;
        // 计算折扣并限制在1-10之间，保留一位小数
        const discount = 10 * (discountAmount / row.jdPrice);
        row.discount = Math.max(0, Math.min(10, discount)).toFixed(1);
        row.payPrice = discountAmount.toFixed(2);
        if (Number(row.discountAmount) < 0.01 || Number(row.discountAmount) > row.jdPrice) {
            this.$set(row, "discountValueValid", true);
          } else {
            this.$set(row, "discountValueValid", false);
          }
        this.form.payPrice = row.payPrice;
      }
    },
    changeShopType(e) {
      if (e == 1) {
        this.form.venderType = 1;
        // this.venderType = false;
      } else {
        this.form.venderType = 0;
        // this.venderType = true;
      }
    },
    confirmToken(e) {
      if (
        new Date(this.form.startTime).getTime() <
        new Date(e.startTime).getTime()
      ) {
        this.$message({
          message: "上下架时间必须在令牌有效期内，请重新设置！",
          type: "warning",
        });
        this.form.startTime = "";
      }
      if (
        new Date(this.form.endTime).getTime() > new Date(e.endTime).getTime()
      ) {
        this.form.endTime = "";
        this.$message({
          message: "上下架时间必须在令牌有效期内，请重新设置！",
          type: "warning",
        });
      }
      this.tokenDetail = e;
      this.form.tokenId = e.id;
      this.selectTokenDialog = false
    },
    //选择令牌
    selectToken(val) {
      this.selectTokenDialog = true;
      this.formList.current = 1;
      this.formList.size = 10;
    },
    upodata() {
      this.$forceUpdate();
    },
    // 复制回显
    getDetail() {
      inquireActivity(this.valueRow.id).then((res) => {
        this.form.ruleDTO = res.data.ruleDTO || {
          activityTargetType: '1',
          partner: ["-1"],
          allowLevel: "-1",
          plusObject: 0,
          crowdIds: "",
          firstOpenCardTimeType: 0,
          openCardBeforeDay: "",
          orderCompleteLimitCount: "",
          orderCompleteMaxCount: "",
          orderCompleteLimitPayment: "",
          orderCompleteMaxPayment: "",
          lastOrderCompleteTimeType: 0,
          lastOrderCompleteStartDay: "",
          lastOrderCompleteEndDay: "",
          lastOrderCompleteStartTime: "",
          lastOrderCompleteEndTime: "",
          isCheckOpenCardTime: "",
          openCardStartTime: "",
          openCardEndTime: "",
        };
        this.form.ruleDTO.activityTargetType = String(this.form.ruleDTO.activityTargetType);
        this.peopleSelected = this.form.ruleDTO.crowdIds ? this.form.ruleDTO.crowdIds.split(',') : [];
        this.$set(this.form.ruleDTO, "partner", this.form.ruleDTO.allowLevel.split(","));
        this.form.ruleDTO.condFollow = this.form.ruleDTO.condFollow ? true : false;
        // 学生身份
        this.form.ruleDTO.studentSatus = res.data.studentSatus || "";
        // 基本信息回显
        this.form.activityName =
          res.data.activityName + (this.activityData.isCopy ? "复制" : "");
        this.form.logo = res.data.logo;
        this.form.ruleDescription = res.data.ruleDescription;
        this.form.startTime = res.data.startTime || "";
        this.form.endTime = res.data.endTime || "";
        this.isKeyActivity = res.data.isKeyActivity || 0;
        this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"];
        this.customerPaperwork = res.data.customerPaperwork ? JSON.parse(res.data.customerPaperwork) : { shopNameType: 0 }
        // 业务功能字段
        this.form.linePrice = res.data.price || null;
        this.points =
          res.data.memberLevelPointsDTOList &&
          res.data.memberLevelPointsDTOList[0] &&
          res.data.memberLevelPointsDTOList[0].point
            ? res.data.memberLevelPointsDTOList[0].point
            : null;
        this.form.payPrice = res.data.payPrice || null;
        this.form.quantityTotal = res.data.quantityTotal || null;
        this.form.exchangePerDayLimit =
          res.data.exchangePerDayLimit !== undefined
            ? res.data.exchangePerDayLimit
            : 0;
        this.form.exchangeNumPerDay = res.data.exchangeNumPerDay || null;
        this.form.exchangeMemberTimes =
          res.data.exchangeMemberTimes !== undefined
            ? res.data.exchangeMemberTimes
            : 1;

        // 商品列表回显
        this.form.goodsList =
          res.data.goodsList &&
          Array.isArray(res.data.goodsList) &&
          res.data.goodsList.length > 0
            ? [...res.data.goodsList]
            : [];

        // 全局商品配置回显
        // if (res.data.globalConfig) {
        //   this.form.globalConfig.priceType = res.data.globalConfig.priceType !== undefined ? res.data.globalConfig.priceType : 0;
        //   this.form.globalConfig.priceVal = res.data.globalConfig.priceVal || null;
        //   this.form.globalConfig.roundMode = res.data.globalConfig.roundMode !== undefined ? res.data.globalConfig.roundMode : 0;
        //   this.form.globalConfig.remanentAmount = res.data.globalConfig.remanentAmount || null;
        // }

        // 商品限购回显
        this.form.minItemNum = res.data.minItemNum !== null && res.data.minItemNum !== undefined ? res.data.minItemNum : null;
        this.form.maxItemNum = res.data.maxItemNum !== null && res.data.maxItemNum !== undefined ? res.data.maxItemNum : null;

        this.fileList = [
          {
            url: res.data.logo,
            name: "积分加钱购",
          },
        ];
        // 更新令牌详情
        if (res.data.promoTokenVO) {
          this.tokenDetail = res.data.promoTokenVO;
          this.form.tokenId = res.data.promoTokenVO.id;
        }
        // 会员等级设置
        if (
          !this.activityData.isCopy &&
          res.data.memberLevelPointsDTOList &&
          Array.isArray(res.data.memberLevelPointsDTOList)
        ) {
          const checkedLevel = res.data.memberLevelPointsDTOList
            .filter((item) => item.allow)
            .map((item) => item.level);
          const allLevel = this.memberLevelList.every((list) =>
            checkedLevel.includes(list.value)
          );
          const isAll = res.data.memberLevelPointsDTOList
            .filter((item) => item.allow)
            .every(
              (item) =>
                item.point === res.data.memberLevelPointsDTOList[0].point
            );

          // 设置会员等级选择状态
          this.memberLe = allLevel;
          this.level = allLevel
            ? this.memberLevelList.map((item) => item.value)
            : checkedLevel;

          // 设置积分统一或单独设置
          this.isLevelSet = !isAll;
          if (isAll) {
            this.form.memberLevelPoints =
              res.data.memberLevelPointsDTOList[0].point;
          }
        }

        // 店铺类型和令牌信息
        this.form.venderType = this.venderType ? 1 : 0;

        // 复制时清空规则说明
        if (this.activityData.isCopy) {
          this.form.ruleDescription = "";
        }

        this.activityTimeChange();
      });
    },
    init() {
      this.giftList = [
        {
          createTime: "2021-11-08 17:02:20",
          days: "",
          expirationType: 0,
          giftPrizeType: 1,
          giftType: 1,
          id: "55",
          openMerchant: "",
          openType: 0,
          imageName: "积分加钱购",
          templateUrl: "https://cdn-image.yucrm.cn/images/Preview/jqg.png",
          updateTime: "2021-11-12 10:19:55",
          templateUItype: 1,
        },
      ];
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },
    getCodeIMG() {
      // const data = await prefixurl();
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      // const url = `${this.activityData.telCode}/clientPreview?activityType=${this.activityData.id}&venderId=${data.data.venderId}`;
      const url = `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=`;
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: url + this.giftList[index].templateUrl,
        });
      }
    },
    nextStepKai(item) {
      this.localStep = 1;
      // 移除隐藏上传组件的代码，确保创建活动时可以正常上传图片
    },
    // 限制大于等于0正数，带两个小数点
    handelInput(dataName, max = -1) {
      let inputValue = this.form[`${dataName}`];

      // 除数字和小数点之外
      inputValue = inputValue.replace(/^\d[0,9]\.[0-9]{2}?$/, "");

      // 限制小数点后两位
      const parts = inputValue.split(".");
      if (parts[0].length > 1 && parts[0].charAt(0) == "0") {
        parts[0] = parts[0].substring(1);
      }
      if (parts.length > 1) {
        parts[1] = parts[1].slice(0, 2);
        inputValue = parts[0] + "." + parts[1];
      } else {
        inputValue = parts[0];
      }

      let value = isNaN(inputValue) ? "" : inputValue.toString();

      if (max != -1 && max < value) {
        value = max;
      }

      // 更新数据
      this.form[`${dataName}`] = value;
      this.$forceUpdate();
    },
    isLevel() {
      this.isLevelSet = !this.isLevelSet;
      this.form.memberLevelPoints = "";
      this.memberLevelList.forEach((item) => {
        item.point = "";
      });
    },
    //会员等级
    getLevel() {
      querymemberLevel().then((res) => {
        this.memberLevelList = res.data.map((item) => {
          let obj = {
            value: item.customerLevel,
            label: item.customerLevelName,
            point: "",
          };
          return obj;
        });
        // 默认全部选中
        this.level = res.data.map((item) => item.customerLevel);
        // 复制、跨店复制、草稿编辑
        if (this.valueRow && this.valueRow.id) {
          this.isCopy = this.activityData.isCopy;
          this.getDetail();
        }
      });
    },
    //输入框限制负数
    checkputn(e) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value <= 0) {
        this.$message({
          message: "请填写大于0的数字",
          type: "warning",
        });
        e.target.value = "";
      }
    },
    //返回
    retrunMethod() {
      if (this.isCopy && this.localStep != 0) return (this.localStep = 0);
      this.form.activityName = "";
      this.form.logo = "";
      this.form.ruleDescription = "";
      this.form.price = null;
      this.form.exchangeTimes = null;
      this.form.quantityTotal = null;
      // this.form.startTime = "";
      // this.form.endTime = "";
      this.level = [1, 2, 3, 4, 5];
      this.memberLe = true;
      this.form.memberLevelPoints = "";
      this.form.couponRedemptionType = ""; //v3.9新增
      this.tokenDetail = {};
      this.form.tokenId = null;
      this.form.goodsList = [];
      // this.$emit("returnback");
      if (this.localStep == 0) this.$emit("returnback");
      if (this.localStep == 1) this.localStep = 0;
    },
    //活动时间驱动
    activityTimeChange(val) {
      // 校验有无时间
      if (!this.form.endTime || !this.form.startTime) return;
      let nowTime = new Date().getTime();
      let start = new Date(this.form.startTime).valueOf();
      let end = new Date(this.form.endTime).valueOf();
      let invalidateDate = new Date(
        this.$store.getters.loginUserInfo.expiresIn
      ).valueOf();
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.form.endTime = null;
        return;
      }
      // if (start < nowTime + 5 * 60 * 1000) {
      //   // thimessage.warning("开始时间不能小于当前时间5分钟");
      //   // thiorm.startTime = null;
      //   // ret;
      // }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        this.form.endTime = null;
        return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        this.form.endTime = null;
        return;
      }

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.form.startTime.substring(0, 10);
      daysEnd = this.form.endTime.substring(0, 10);
      if (this.form.endTime != "" && this.form.startTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 =
          new Date(this.form.endTime).getTime() -
          new Date(this.form.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
    },
    //选中改变
    checkListchange(val) {
      if (val) {
        this.level = this.memberLevelList.map((item) => item.value);
      } else {
        this.level = [];
      }
    },

    checkTheChange(val) {
      if (val.length == 5) {
        this.memberLe = true;
      } else {
        this.memberLe = false;
      }
    },

    dialogForm() {
      this.dialogFormVisible = true;
      this.getSeller();
      this.getShopList();
    },
    //获取店铺商品
    getShopList() {
      this.loading = true;
      let params = {
        ...this.pageInfo,
        ...this.formShopList,
      };
      if (this.venderType) {
        params.skuIdStr = this.tokenDetail.detailList
          ? this.tokenDetail.detailList[0].promoSku
          : this.tokenDetail.promoSkus;
      }
      getTaobaoItemListSku(params)
        .then((res) => {
          this.loading = false;
          this.tableShopData = res.data.records;
          this.totalList = res.data.total;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 获取商品类目
    getSeller() {
      getSellercats().then((res) => {
        let data = this.transverter(res.data);
        this.getTrees(data);
        let list = data.filter((item) => item.parent_id == 0);
        let cascaderArr = list.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.children,
          };
        });
        this.commodityList[0].options = cascaderArr;
      });
    },
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },

    //选择商品
    chooseShop(val) {
      const { skuId, wareId, skuName, logo, jdPrice } = val;
      const skuIds = [skuId];
      this.sureLoading = true;
      checkProduct(skuIds)
        .then((res) => {
          this.sureLoading = false;
          if (res.code == 1) {
            if (res.data.isHave) {
              this.$message.warning("活动暂不支持选择虚拟套装和影分身商品");
            } else {
              // 清空数组，确保只能选择一个奖品
              this.form.goodsList = [];
              this.form.goodsList.push({
                id: "",
                skuId,
                wareId,
                skuName, // 商品名称
                wareTitle: skuName,
                jdPrice, // 京东价
                logo, // 商品图片
                prizeType: 3, // 实物类型
                discount: "",
                discountAmount: "",
                payPrice: jdPrice,
              });
              this.form.linePrice = jdPrice; // 设置划线价为京东价
              this.form.payPrice = jdPrice;
              // 关闭商品选择对话框
              this.dialogFormVisible = false;
            }
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.sureLoading = false;
        });
      // // 清空数组，确保只能选择一个奖品
      // this.form.goodsList = [];
      // this.form.goodsList.push({
      //   id: "",
      //   skuId,
      //   wareId,
      //   skuName, // 商品名称
      //   wareTitle: skuName,
      //   jdPrice, // 京东价
      //   logo, // 商品图片
      //   prizeType: 3, // 实物类型
      //   discount: "",
      //   discountAmount: "",
      //   payPrice: jdPrice,
      // });
      // this.form.linePrice = jdPrice; // 设置划线价为京东价
      // this.form.payPrice = jdPrice;
      // // 关闭商品选择对话框
      // this.dialogFormVisible = false;
    },

    // 选择店铺
    selectStore() {
      // 店铺选择功能的实现
      this.$message.info("店铺选择功能待实现");
    },
    searchContent(val) {
      this.pageInfo.size = 5;
      this.pageInfo.current = 1;
      if (val.categoryId) {
        this.formShopList.categoryId = val.categoryId.join(",");
      } else {
        this.formShopList.categoryId = "";
      }
      this.formShopList.skuId = val.skuId;
      this.formShopList.skuIdStr = val.skuId;
      this.formShopList.skuName = val.skuName;
      this.formShopList.skuStatus = val.skuStatus;
      this.getShopList();
    },

    //上传图片
    handleChange(file, fileList) {
      // 检查文件格式，只允许JPG和PNG
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt3M = file.size < 1024 * 1024 * 1.5;

      if (!isJPG && !isPNG) {
        this.$message.error("上传图片必须是 JPG 或 PNG 格式");
        this.$refs.upload.clearFiles();
        return;
      }

      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 1.5MB");
        this.$refs.upload.clearFiles();
      } else {
        this.fileList = fileList;
        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.form.logo = res.data;
        });
      }
    },
    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      this.form.logo = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    httpRequest() {},
    // 日期格式化函数
    dateFormat(time) {
      let date = new Date(time);
      let year = date.getFullYear();
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 生成规则
    generativerule() {
      // 构建符合要求的活动规则
      let rules = [];
      let levelStr = [];
      this.memberLevelList.forEach((item) => {
        if (this.level.includes(item.value)) {
          levelStr.push(item.label);
        }
      });

      // 检查是否选择了商品
      if (!this.form.goodsList || this.form.goodsList.length === 0) {
        this.$message.warning("请选择商品");
        return;
      }

      if (!this.form.startTime) {
        this.$message.warning("请输入上下架时间");
        return;
      }

      if (!this.form.endTime) {
        this.$message.warning("请输入上下架时间");
        return;
      }

      if (this.memberLevelList.length == 0) {
        this.$message.warning("请选择会员等级");
        return;
      }

      // 1. 商品名称
      if (this.form.goodsList && this.form.goodsList.length > 0 && this.form.goodsList[0].skuName) {
        rules.push(`1.商品名称：${this.form.goodsList[0].skuName}`);
      } 


      // 2. 上下架时间 - 添加日期格式化
      if (this.form.startTime && this.form.endTime) {
        const startTimeFormatted = this.dateFormat(this.form.startTime);
        const endTimeFormatted = this.dateFormat(this.form.endTime);
        rules.push(`2.上下架时间：${startTimeFormatted}~${endTimeFormatted}`);
      }

      // 3. 兑换所需等级
      if (this.memberLe) {
        rules.push(`3.兑换所需等级：全部`);
      } else {
        rules.push(`3.兑换所需等级：${levelStr.splice(",")}`);
      }

      //分自营和非自营
      rules.push(
        `4.兑换消耗所需要${this.points}积分，兑换成功后促销价格${this.form.payPrice}元`
      );

      // 5. 数量有限提示
      rules.push(`5.礼品数量有限，先到先得，有可能会有礼品擦肩而过情况`);

      // 6. 恶意行为提示
      rules.push(
        `6.若用户存在刷奖等恶意行为，一经发现将取消获奖资格（如奖品已经发放，有权追回奖品）`
      );

      // 组合所有规则文本
      this.form.ruleDescription = rules.join("；\n") + "；";
    },

    clearTime() {
      this.form.startTime = "";
      this.form.endTime = "";
    },

    jumpRC() {
      let routeUrl = this.$router.resolve({
        path: "/tool/prizeCenter/assetManagement",
        query: { tabAct: 6 },
      });
      window.open(routeUrl.href, "_blank");
    },

    // 查询资产账户余额
    allSearch() {
      let sum = 0;
      let sum2 = 0;
      let sum3 = 0;
      allAccount({ type: 8 }).then((res) => {
        res.data.forEach((item) => {
          sum += item.quantityBalance;
        });
        res.data.forEach((item) => {
          sum2 += item.quantityTotal;
        });
        res.data.forEach((item) => {
          sum3 += item.quantityFrozen;
        });
        this.quantityBalance = sum;
        this.quantityTotal = sum2;
        this.quantityFrozen = sum3;
      });
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.form.activityName) {
        this.$message.warning("请输入礼品名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    //创建礼品兑换活动
    setActivity() {

      //活动创建限制 - 礼品名称
      if (!this.form.activityName) {
        this.$message.warning("请输入礼品名称");
        return;
      }
      const ruleDTO = this.form.ruleDTO;
      if (ruleDTO.activityTargetType == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }
      if (ruleDTO.activityTargetType == "2") {
        if (
          ruleDTO.firstOpenCardTimeType == 1 &&
          !ruleDTO.openCardBeforeDay
        ) {
          this.$message.warning("请完善首次入会时间");
          return;
        }
        if (
          ruleDTO.firstOpenCardTimeType == 2 &&
          (!ruleDTO.openCardStartTime || !ruleDTO.openCardEndTime)
        ) {
          this.$message.warning("请完善首次入会时间");
          return;
        }
        if (
          ruleDTO.lastOrderCompleteTimeType == 1 &&
          (!ruleDTO.lastOrderCompleteStartDay &&
            !ruleDTO.lastOrderCompleteEndDay)
        ) {
          this.$message.warning("请完善购物条件");
          return;
        }
        if (
          ruleDTO.lastOrderCompleteTimeType == 2 &&
          (!ruleDTO.lastOrderCompleteStartTime ||
            !ruleDTO.lastOrderCompleteEndTime)
        ) {
          this.$message.warning("请完善购物条件");
          return;
        }
      }
      // // 礼品图片
      // if (!this.form.logo) {
      //   this.$message.warning("请添加礼品图片");
      //   return;
      // }

      // 上下架时间
      if (!this.form.startTime) {
        this.$message.warning("请选择上架时间");
        return;
      }
      if (!this.form.endTime) {
        this.$message.warning("请选择下架时间");
        return;
      }

      // 时间逻辑校验
      let nowTime = new Date().getTime();
      let start = new Date(this.form.startTime).valueOf();
      let end = new Date(this.form.endTime).valueOf();

      // 检查开始时间必须大于当前时间5分钟
      if (start < nowTime + 5 * 60 * 1000) {
        this.$message.warning("开始时间不能小于当前时间5分钟");
        return;
      }

      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }

      // 令牌选择（自营店铺必填）
      if (this.venderType && !this.tokenDetail.tokenId) {
        this.$message.warning("请选择令牌");
        return;
      }

      // 商品选择（非自营店铺或已选令牌必填）
      if (
        (!this.venderType || this.form.tokenId) &&
        this.form.goodsList.length === 0
      ) {
        this.$message.warning("请选择商品");
        return;
      }

      if(this.form.goodsList.length&&this.form.goodsList.some((item=>!item.discount||!item.discountAmount))){
        this.$message.warning("请填写折扣价或减价金额！");
        return;
      }
 
      

      // // 促销价格校验
      // if (!this.venderType || this.form.tokenId) {
      //   if (this.form.globalConfig.priceVal === null || this.form.globalConfig.priceVal === undefined || this.form.globalConfig.priceVal === '') {
      //     this.$message.warning("请填写折扣价或减价金额！");
      //     return;
      //   }
      // }

      // 划线价
      if (!this.form.linePrice) {
        this.$message.warning("请设置划线价");
        return;
      }

      // 兑换消耗校验
      if (!this.points) {
        this.$message.warning("请输入兑换消耗积分");
        return;
      }
      if (!this.form.payPrice) {
        this.$message.warning("请输入兑换消耗金额");
        return;
      }

      // 礼品兑换总量校验
      if (!this.form.quantityTotal) {
        this.$message.warning("请输入礼品兑换总量");
        return;
      }

      // 每日最多可兑数量校验
      if (this.form.exchangePerDayLimit === 1 && !this.form.exchangeNumPerDay) {
        this.$message.warning("请输入每日最多可兑数量");
        return;
      }

      // 兑换所需等级校验
      if (!this.memberLe && this.level.length === 0) {
        this.$message.warning("请选择兑换所需等级");
        return;
      }

      // 规则说明校验
      if (!this.form.ruleDescription) {
        this.$message.warning("请输入规则说明");
        return;
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.showSetDialog = true;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    handleDialogCloseAnoth() {
      if (this.checked || this.isDraft) {
        // 直接使用this.form中的值创建obj对象
        let obj = {
          // 基本活动信息
          activityName: this.form.activityName,
          activityType: this.tabActive, // 直接使用tabActive而不是硬编码的38
          endTime: this.form.endTime,
          startTime: this.form.startTime,
          logo: this.form.logo,
          ruleDescription: this.form.ruleDescription,
          tokenId: this.venderType ? this.form.tokenId : null,

          // 价格相关信息
          linePrice: this.form.linePrice ? Number(this.form.linePrice) : null,
          payPrice: this.form.payPrice ? Number(this.form.payPrice) : null,
          //店铺类型
          venderType: this.form.venderType,
          // 礼品兑换总量
          quantityTotal: this.form.quantityTotal
            ? Number(this.form.quantityTotal)
            : null,
          // 每日兑换限制
          exchangePerDayLimit: this.form.exchangePerDayLimit,
          exchangeNumPerDay: this.form.exchangeNumPerDay
            ? Number(this.form.exchangeNumPerDay)
            : null,
          // 会员兑换规则
          exchangeMemberTimes: this.form.exchangeMemberTimes,

          // 积分列表初始化为空数组
          memberLevelPointsDTOList: [],

          // 过滤
          goodsList: this.form.goodsList,
          isKeyActivity: this.isKeyActivity,
          placementPosition: this.placementPosition.join(","),
          customerPaperwork: JSON.stringify(this.customerPaperwork),
          // 全局商品配置（给前端计算使用）
          // globalConfig: {
          //   priceType: this.form.globalConfig.priceType,
          //   priceVal: this.form.globalConfig.priceVal !== null && this.form.globalConfig.priceVal !== undefined ? Number(this.form.globalConfig.priceVal) : null,
          //   roundMode: this.form.globalConfig.roundMode,
          //   remanentAmount: this.form.globalConfig.remanentAmount !== null && this.form.globalConfig.remanentAmount !== undefined ? Number(this.form.globalConfig.remanentAmount) : null,
          // },
          minItemNum: this.form.minItemNum !== null && this.form.minItemNum !== undefined ? Number(this.form.minItemNum) : null,
          maxItemNum: this.form.maxItemNum !== null && this.form.maxItemNum !== undefined ? Number(this.form.maxItemNum) : null,
          studentStatus: this.form.ruleDTO.studentStatus,
        };
        obj.ruleDTO = this.form.ruleDTO;
        delete obj.ruleDTO.studentStatus;
        obj.ruleDTO.crowdIds = this.peopleSelected.join(",");
        if(obj.ruleDTO.activityTargetType != 2) {
          obj.ruleDTO.allowLevel = "-1";
        } else {
          obj.ruleDTO.allowLevel = obj.ruleDTO.partner.join(",");
        }
        // 处理兑换所需积分
        obj.memberLevelPointsDTOList = this.memberLevelList.map((item) => {
          const checked = this.level.includes(item.value);
          return {
            allow: checked,
            level: item.value,
            levelName: item.label,
            point: this.points,
          };
        });
        if (this.isDraft) {
          obj.status = 5;
        }
        // 草稿箱编辑-添加活动id
        if (this.isDraftEdit) {
          obj.id = this.valueRow.id;
        }
        if (this.activityData.singleCopy) {
          delete obj.id;
        }
        addMoneyActivity(obj).then((res) => {
          if (res && res.code == 1) {
            if (this.isDraft) {
              this.$emit("returnback", true);
            } else {
              this.memberLevelPointsDTOList = [];
              this.$message.success(res.message);
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
            }
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.error("请勾选明确活动规则后即可创建");
      }
    },
    //分页事件
    handleChangePage(page) {
      this.pageInfo.current = page.pageNum;
      this.pageInfo.size = page.pageSize;
      this.getShopList();
    },
    // 批量修改商品价格相关字段
    changeGoodsPrice(value, type, rowIndex) {
      // 促销价格/统一奖品数量点击时的验证
      if (rowIndex === undefined && (type == 1 || type == 2 || type == 3)) {
        if (value === null || value === undefined || value === '') {
          this.$message.warning(type == 3 ? "请填写统一奖品数量！" : "请填写折扣价或减价金额！");
          return;
        }
      }
      if (!this.form.goodsList || this.form.goodsList.length === 0) {
        return;
      }
      value = Number(value);
      if (isNaN(value)) {
        return;
      }
      if (rowIndex !== undefined) {
        // 修改单行
        const row = this.form.goodsList[rowIndex];
        if (type == 1) {
          row.discount = value;
        } else if (type == 2) {
          row.discountAmount = value;
        } else if (type == 3) {
          row.remanentAmount = value;
        }
      } else {
        // 批量修改所有商品
        this.form.goodsList.forEach((row) => {
          if (type == 1) {
            row.discount = value;
          } else if (type == 2) {
            row.discountAmount = value;
          } else if (type == 3) {
            row.remanentAmount = value;
          } else if (type == 4) {
            // 抹零设置，不修改商品列表，只更新全局配置
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.level-wrap {
  display: flex;
  /deep/.el-checkbox-group {
    margin-right: 16px;
  }
}
.createPlayStep {
  height: 100%;
  background: #ffffff;
  padding-bottom: 0;
}
.firststep {
  min-height: 820px;
  box-sizing: border-box;
  padding: 0px 35px 25px;
}
.create_coupons {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 6px;
  .head {
    flex-shrink: 0;
    box-sizing: border-box;
    padding-left: 24px;
    height: 50px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f6f6f6;
    font-size: 14px;
    div {
      display: flex;
      align-items: center;
      color: #999;
      cursor: pointer;
      img {
        margin-right: 4px;
      }
    }
    .t {
      margin: 0 20px;
      color: #ccc;
    }
    .txt {
      color: #333;
    }
  }
  .main {
    flex: 1;
    box-sizing: border-box;
    padding: 0px 0 0 24px;
    .addBtn {
      width: 98px !important;
      height: 32px;
      line-height: 28px;
      border: 1px solid #2768ff;
      color: #2768ff;
      &:hover {
        background-color: #2768ff;
        color: #fff;
      }
    }
    .couponContent {
      height: 130px;
      width: 260px;
      border: 1px solid #dddddd;
      border-radius: 10px;
      position: relative;
      .txtNum {
        position: absolute;
        margin: 25px;
        width: 160px;
      }
      .txtSize {
        margin: 20px 0 0 140px;
        line-height: 22px;
      }
      .time {
        font-size: 12px;
        margin-left: 30px;
        color: #999999;
      }
      .btn {
        display: none;
        opacity: 0;
      }
      &:hover {
        box-shadow: 0px 0px 8px 2px #dddddd;
        .btn {
          display: inline;
          margin: -17px 0 0 -49px;
          opacity: 1;
          position: absolute;
          left: 50%;
          top: 50%;
        }
        .background {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 10px;
          background-color: #fff;
          opacity: 0.7;
        }
      }
    }
    .pContent {
      // display: block;
      float: left;
      width: 250px;
      color: #999999;
    }
    .limitBox {
      display: flex;
      align-items: center;
      .desc {
        margin-left: 32px;
        font-size: 13px;
        color: #999;
        i {
          color: #fe8f8a;
          opacity: 0.8;
        }
      }
    }
    .lastTime {
      color: #333;
    }
    .isLevelSet {
      // display: flex;
      .levelList {
        display: flex;
        flex-wrap: wrap;
        width: 280px;
        float: left;
        .item {
          // width: 50%;
          text-align: right;
          margin-bottom: 16px;
          font-size: 14px;
          color: #333;
        }
      }
      .setBtn {
        width: 115px;
        height: 32px;
        line-height: 28px;
        margin-left: 10px;
        // margin-left: 20px;
        border: 1px solid #2768ff;
        color: #2768ff;

        background: rgba(123, 97, 255, 0.1);
        font-size: 13px;
        &:hover {
          background-color: #2768ff;
          color: #fff;
        }
      }
    }
    .generate {
      border: 1px solid #7f85e9;
      background: rgba(127, 133, 233, 0.1);
      color: #7f85e9;
      width: 76px;
      height: 28px;
      line-height: 24px;
    }
    .txt {
      margin-left: 12px;
      color: #999;
      font-size: 13px;
    }
  }
  .foot {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    // width: 100%;
    // position: absolute;
    bottom: -150px;
    justify-content: flex-start;
    height: 80px;
    border-top: 1px solid #f6f6f6;
    margin-left: 88px;
  }
  p {
    margin: 0;
  }
  button {
    height: 34px;
    text-align: center;
    // border: none;
    // background-color: white;
    outline: none;
    cursor: pointer;
    border-radius: 3px;
    transition: all 0.2s;
  }
}
.rule-tip {
  margin-top: 8px;
}
.item-wrap {
  display: flex;
  align-items: center;
}

.tokenDetial-item {
  display: flex;
  align-items: center;
  margin-top: 18px;
  color: #666;
  & > span {
    width: 100px;
    display: flex;
    justify-content: right;
  }
}

.tip-color {
  color: red;
}
::v-deep .red-border {
  color: #f56c6c;
  font-size: 12px;
  input {
    border: 1px solid #f56c6c !important;
  }
}
.pd20 {
  padding: 20px 20px 16px;
}
</style>
